import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  const inputAdornmentOffset = 1.75;

  return {
    inputAdornment: {
      marginRight: theme.spacing(0.25),
      marginLeft: theme.spacing(-1 * inputAdornmentOffset),
    },
    menuProps: {
      height: '300px',
      width: '360px',
      top: 0,
      left: theme.spacing(-4),
    },
    countrySelect: {
      width: 'max-content',
      // Remove default outline (display only on focus)
      fieldset: {
        display: 'none',
      },
      '&.Mui-focused:has(div[aria-expanded="false"])': {
        fieldset: {
          display: 'block',
        },
      },
      // Update default spacing
      '.MuiSelect-select': {
        padding: theme.spacing(1),
        paddingLeft: theme.spacing(inputAdornmentOffset),
        paddingRight: `${theme.spacing(3)} !important`,
      },
      svg: {
        right: 0,
      },
    },
    selectedFlag: {
      display: 'flex',
    },
    selectedFlagDisabled: {
      opacity: 0.25,
    },
    menuItem: {
      display: 'flex',
      gap: theme.spacing(1),
    },
    optionFlag: {},
    optionName: {},
    optionDialCode: {
      color: theme.palette.text.secondary,
    },
    dialCode: {
      color: theme.palette.text.primary,
    },
    dialCodeDisabled: {
      color: theme.palette.text.disabled,
    },
  };
};
